import { MouseEvent, useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
  PayPalButton,
  PayPalButtonProps,
} from "chameleon/lib/components/paypal/paypal-button";

import { useChexContext } from "checkout-experience/providers/chex-context-wrapper";

import { PayPalButtonColor, PayPalButtonLabel } from "frontend-client";

interface Props {
  isPayInProgress?: boolean;
  handleOnClick: (e: MouseEvent | undefined) => Promise<void>;
}

const PayPal = ({ isPayInProgress, handleOnClick }: Props) => {
  const { t } = useTranslation();
  const { merchantSettings } = useChexContext();
  const { buttonColor, buttonLabel } = merchantSettings?.paymentMethods
    ?.altPaymentMethod?.paypal ?? {
    buttonColor: PayPalButtonColor.GOLD,
    buttonLabel: PayPalButtonLabel.DEFAULT,
  };

  const variant: PayPalButtonProps["variant"] = useMemo(() => {
    switch (buttonColor) {
      case PayPalButtonColor.BLACK:
        return "black";
      case PayPalButtonColor.BLUE:
        return "blue";
      case PayPalButtonColor.SILVER:
        return "silver";
      case PayPalButtonColor.WHITE:
        return "white";
      default:
        return "gold";
    }
  }, [buttonColor]);

  const text = useMemo(() => {
    switch (buttonLabel) {
      case PayPalButtonLabel.BUY_NOW:
        return t("paypalButton.buyNow");
      case PayPalButtonLabel.PAY_WITH:
        return t("paypalButton.payWith");
      case PayPalButtonLabel.CHECKOUT:
        return t("paypalButton.checkout");
      default:
        return "";
    }
  }, [buttonLabel]);

  return (
    <PayPalButton
      testId={"paypal-place-order"}
      position={buttonLabel === PayPalButtonLabel.PAY_WITH ? "right" : "left"}
      text={text}
      isLoading={isPayInProgress}
      isDisabled={isPayInProgress}
      onClick={handleOnClick}
      variant={variant}
    />
  );
};

export default PayPal;
